module.exports = __webpack_public_path__ + "img/TurquoisePrincess_DG.aa9ca520.png";